import {switchMap} from 'rxjs';
import {
  FarmerRecomendationReport,
  ReportService,
} from '@6grain/masofa-monolith-api-client/crop-monitoring';

/** GET full report, then PUT with the given fields merged in. */
export function updateFarmerRecommendationReport(
  service: ReportService,
  reportId: string,
  patch: Partial<FarmerRecomendationReport>,
) {
  return service.cropMonitoringReportGetByIdIdGet(reportId).pipe(
    switchMap((report: FarmerRecomendationReport) =>
      service.cropMonitoringReportUpdatePut({
        ...report,
        ...patch,
      }),
    ),
  );
}
